import { render, staticRenderFns } from "./PointsLog.vue?vue&type=template&id=51bfa66c&scoped=true"
import script from "./PointsLog.vue?vue&type=script&lang=js"
export * from "./PointsLog.vue?vue&type=script&lang=js"
import style0 from "./PointsLog.vue?vue&type=style&index=0&id=51bfa66c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bfa66c",
  null
  
)

export default component.exports